import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { httpservice, Message } from 'src/app/commons/commons.module';
import { Korisnik } from 'src/app/_models/korisnik';
import { FormsModule,FormControl } from '@angular/forms';
import { LoginService } from 'src/app/login/login.service';
import { User } from 'src/app/_models/user';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'korisnik-select',
  templateUrl: './korisnik-select.component.html',
  standalone: true,
  imports: [CommonModule,MatAutocompleteModule, MatCardModule,MatFormFieldModule, MatButtonModule, MatInputModule, MatSelectModule,  FormsModule],
})

export class KorisnikSelectComponent implements OnInit {
  getservice: httpservice;
  qkorisnik: any;
  listakorisnika: Korisnik[];
  korisnikCtrl = "";
  loginService: LoginService;
  login: User;
  @Output() podaci = new EventEmitter<string>();

  constructor(dataservice: httpservice, loginservice: LoginService) {
    this.getservice = dataservice;
    this.loginService = loginservice;
  }

  ngOnInit() {
    this.qkorisnik = "";
    this.korisnikCtrl ="";
    this.loginService.currentUser.subscribe(data => {
      this.login = data;      
    });
  }

  

  onchangeKorisnik(value) {
    if (value.length == 8) {
      this.qkorisnik = value;      
    }
    else {
      this.qkorisnik = "";
    }
    this.podaci.emit(this.qkorisnik);
      this.popuniListu();    
  }

  popuniListu() {
    if (this.korisnikCtrl !== "") {
      this.getservice.GetRequest<Message>("komunalno/korisnik/search?searchstring=" + this.korisnikCtrl).subscribe(result => {
        if (result.status === "success") {
          this.listakorisnika = result.data;
        }
      }, error => console.error('Get korisnike', error));
    }
  }
  
}

